import { ReactElement } from 'react';
import { AlertColor } from '@mui/material';

import { MessageUser, MinimalTarget, MinimalUser } from './generated/model';

export type PopupType = {
  title?: string;
  icon?: ReactElement;
  element?: ReactElement | undefined;
  showToken: boolean;
  mainFunction: boolean;
  requiredExtraFeature?: string;
  showMobile: boolean;
  dataQaElementId?: string;
  children?: PopupType[];
  path: string;
  navigateTo?: string;
  activeOnSubRoutes?: boolean;
  level: number; // 1, 2, 3
  // olyan PopupType, ami nem jelenik meg a menuben
  // de lesz belole route definicio
  hidden?: boolean;
  show?: (user?: MinimalUser, chatId?: string) => boolean;
};

export type FormError<T> = { [K in keyof T]?: string | undefined };

export type State<T> = {
  globalError?: string;
  errors: FormError<T>;
  success?: boolean;
};

// null: nincs bejelentkezve, undefined: nem tudjuk
export type UserState = MinimalUser | null | undefined | 'token_failure' | 'password_reset' | 'change_password';

export type UserMessage = {
  message: string | undefined;
  date: number;
};

export enum TabValue {
  targetSelect,
  dateSelect,
  result,
}

export enum ReportTabValue {
  dateSelect,
  categorySelect,
  entitySelect,
  result,
}

export type ReportTabs = 'TargetTab' | 'DriverTab' | 'TargetReportTab' | 'DriverReportTab' | 'StatusTab';

export enum TargetAttributesTabValue {
  categorySelect,
  entitySelect,
  result,
}

export type SelectedRoute = {
  id: number;
  target: MinimalTarget;
  fromTimeMicros: number;
  toTimeMicros: number;
};

export type Mode = 'target' | 'route';

export type ThreadUserThreadId = {
  user: MessageUser;
  threadId: number;
};

// FIXME remove this ???
export type LoginAutocompleteData = {
  username: string;
  password: string;
};

export type PlatformInformation = {
  app: {
    name: string;
    package: string;
    version: string;
    buildNumber: string;
  };
  os: {
    name: string;
    version: string;
    buildId: string;
    codeName: string;
    sdk: string;
  };
  display: {
    screen: {
      width: number;
      height: number;
    };
    viewport: {
      width: number;
      height: number;
    };
    safePadding: {
      top: number;
      bottom: number;
      left: number;
      right: number;
    };
  };
  model: {
    brand: string;
    name: string;
    codeName: string;
    isPhysical: boolean;
  };
};

export type Identifiable = {
  id: string | number;
  name?: string | undefined;
  description?: string | undefined;
};

/*
  true: engedelyezve van
  false: nincs engedelyezve
  off: user nem engedelyezi
  notsupported: nem appban futunk vagy a flutter azt mondta h not supported
  notavailable: localstorage ures vagy flutter szerint nincs elmentve usernev/jelszo
  dunno: nem tudjuk, atmeneti allapot amig a flutterre varunk
*/
export type BiometicLoginSupport = 'true' | 'false' | 'off' | 'notsupported' | 'notavailable' | 'dunno';

export type NotificationMessage = {
  severity: AlertColor;
  message: string;
  onClose?: () => void;
  timeoutSec?: number | undefined;
};

export type LoaderProps = 'tetris' | 'circular';
